var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Question } from 'packages/form/entities/question/Question';
import Vue from 'vue';
import Component from 'vue-class-component';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
import { Prop } from 'vue-property-decorator';
import { DateUtility } from 'packages/utilities/DateUtility';
import UiCheckbox from 'ui/v1/controls/UiCheckbox.vue';
import UiRadioButton from 'ui/v1/controls/UiRadioButton.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import BallLoader from '../loaders/BallLoader.vue';
import DownloadHelper from 'common/support/DownloadHelper';
var ResponseAnswer = /** @class */ (function (_super) {
    __extends(ResponseAnswer, _super);
    function ResponseAnswer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = null;
        _this.options = {
            fullWidth: true,
            chartPadding: {
                right: 40,
            },
        };
        return _this;
    }
    Object.defineProperty(ResponseAnswer.prototype, "answer", {
        get: function () {
            var _a;
            return (_a = this.question) === null || _a === void 0 ? void 0 : _a.answer;
        },
        enumerable: false,
        configurable: true
    });
    ResponseAnswer.prototype.formatDate = function (dateString) {
        return new DateUtility(dateString).format();
    };
    ResponseAnswer.prototype.downloadFile = function (file) {
        return DownloadHelper.downloadFile(file);
    };
    ResponseAnswer.prototype.optionSelected = function (uuid) {
        if (typeof this.question.answer === 'object') {
            return this.question.answer
                .some(function (answer) { return answer === uuid; });
        }
        return this.question.answer === uuid;
    };
    ResponseAnswer.prototype.openInBlank = function (path) {
        window.open(path, '_blank');
    };
    var _a;
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", typeof (_a = typeof Question !== "undefined" && Question) === "function" ? _a : Object)
    ], ResponseAnswer.prototype, "question", void 0);
    ResponseAnswer = __decorate([
        Component({
            components: {
                Icon: Icon, UiRadioButton: UiRadioButton, UiCheckbox: UiCheckbox, UiTextButton: UiTextButton, BallLoader: BallLoader,
            },
        })
    ], ResponseAnswer);
    return ResponseAnswer;
}(Vue));
export default ResponseAnswer;
